export const MAX_JOB_NAME_LENGTH = 100;